import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const RupeeCircleFilled = ({
  color = '#5FAFFF',
  size = 24,
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <Path
      d="M12 2.24023C6.60999 2.24023 2.23999 6.61023 2.23999 12.0002C2.23999 17.3902 6.60999 21.7602 12 21.7602C17.39 21.7602 21.76 17.3902 21.76 12.0002C21.76 6.61023 17.39 2.24023 12 2.24023ZM15.2 8.44023L13.03 8.44023C13.51 8.80023 13.82 9.31023 13.92 9.88023H15.2V10.7702H13.93C13.77 12.0602 12.82 12.7802 11.85 12.9402L14.02 16.4302H12.22L10.25 13.1102L8.79999 13.1102V11.7402L10.84 11.7402C11.55 11.7402 12.09 11.3702 12.29 10.7702L8.79999 10.7702V9.88023H12.3C12.13 9.27023 11.57 8.92023 10.83 8.92023H8.78999V7.55023L15.18 7.55023V8.44023H15.2Z"
      fill={color}
    />
  </Svg>
)

export default RupeeCircleFilled
